import { AuthWebApi } from 'app/web-api/common/auth.api';

export const webApiServices = [
    AuthWebApi
];

// Explicit export statement
export {};